module.exports = __webpack_public_path__ + "static/media/LQ_Roseto Sand_DK Grey.8fe0c570.png";